import Observer from '../../common/scripts/observer';

const observer = new Observer();

class MapRoutes {
    /**
     * Базовые свойства
     * @constructor
     */
    constructor() {
        this.isSet = false;
        this.target = null;
        this.route = {
            from: [],
            to  : [],
            type: ''
        };
        this.activeClass = 'is-active';
        this.buttons = null;
    }

    /**
     * Инициализирует плагин
     * @param {Object} outerSettings - настройки из внешнего файла
     */
    init(outerSettings) {
        this.target = outerSettings.target;
        this.buttons = Array.from(this.target.querySelectorAll('.j-map-route'));

        this._bindEvents();
    }

    /**
     * Навешивает обработчики
     */
    _bindEvents() {
        this.buttons.forEach((button) => {
            button.addEventListener('click', (event) => {
                const target = event.currentTarget;

                this.route = {
                    from: [],
                    to  : [],
                    type: ''
                };

                target.dataset.routeFrom.split(',')
                    .forEach((coords) => {
                        this.route.from.push(parseFloat(coords));
                    });
                target.dataset.routeTo.split(',')
                    .forEach((coords) => {
                        this.route.to.push(parseFloat(coords));
                    });
                this.route.type = target.dataset.routeType;

                this._changeState(target);

                observer.publish('map:setRoute', this.route);
            });
        });
    }

    /**
     * Изменяет состояние активности у кнопки
     * @param {Node} target - кнопка по которой кликнули
     */
    _changeState(target) {
        this.buttons.forEach((button) => {
            const method = button === target ? 'add' : 'remove';

            button.classList[method](this.activeClass);
        });
        this.isSet = true;
    }

    /**
     * Удаляет класс активности у кнопок
     */
    removeActiveState() {
        this.buttons.forEach((button) => {
            button.classList.remove(this.activeClass);
        });
        this.isSet = false;
    }
}

export default MapRoutes;
